import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const TermsAndConditions = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen" style={{ background: '#F9FAFB' }}>
      <header className="bg-white shadow-sm border-b" style={{ borderColor: '#E5E7EB' }}>
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center gap-4">
          <button onClick={() => navigate('/')} className="flex items-center gap-2 px-4 py-2 text-gray-700 hover:bg-gray-100 rounded-lg transition">
            <ArrowLeft size={20} />
            Back to Home
          </button>
          <h1 className="text-2xl font-bold" style={{ fontFamily: 'Merriweather, serif', color: '#002147' }}>Terms and Conditions</h1>
        </div>
      </header>

      <div className="max-w-4xl mx-auto px-6 py-12">
        <div className="bg-white rounded-lg shadow-sm p-8">
          <p className="text-sm text-gray-600 mb-8">Last Updated: {new Date().toLocaleDateString()}</p>

          <section className="mb-8">
            <h2 className="text-2xl font-bold mb-4" style={{ color: '#002147' }}>1. Acceptance of Terms</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              By accessing and using this School Admission Portal ("the Portal"), you accept and agree to be bound by the terms and conditions outlined in this agreement. If you do not agree to these terms, please do not use the Portal.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold mb-4" style={{ color: '#002147' }}>2. Application Fee</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              • Application fee of ₹200 is non-refundable and must be paid to access the admission form.
            </p>
            <p className="text-gray-700 leading-relaxed mb-4">
              • Payment is processed through Razorpay, a secure payment gateway.
            </p>
            <p className="text-gray-700 leading-relaxed mb-4">
              • Upon successful payment, login credentials will be sent to your registered email and phone number.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold mb-4" style={{ color: '#002147' }}>3. Application Process</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              • Parents/Guardians must provide accurate and complete information in the admission form.
            </p>
            <p className="text-gray-700 leading-relaxed mb-4">
              • Required documents must be uploaded in supported formats (PDF, JPG, PNG).
            </p>
            <p className="text-gray-700 leading-relaxed mb-4">
              • Submission of application does not guarantee admission.
            </p>
            <p className="text-gray-700 leading-relaxed mb-4">
              • The school reserves the right to reject any application without providing reasons.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold mb-4" style={{ color: '#002147' }}>4. Interview Process</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              • Interview dates and times will be scheduled by the school administration.
            </p>
            <p className="text-gray-700 leading-relaxed mb-4">
              • Parents will be notified via email and SMS about the interview schedule.
            </p>
            <p className="text-gray-700 leading-relaxed mb-4">
              • Failure to attend the scheduled interview may result in application rejection.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold mb-4" style={{ color: '#002147' }}>5. Document Verification</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              • All documents submitted must be genuine and verifiable.
            </p>
            <p className="text-gray-700 leading-relaxed mb-4">
              • Submission of fake or forged documents will lead to immediate rejection and possible legal action.
            </p>
            <p className="text-gray-700 leading-relaxed mb-4">
              • Original documents must be presented during the interview for verification.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold mb-4" style={{ color: '#002147' }}>6. Privacy and Data Protection</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              • Personal information collected during the application process will be used solely for admission purposes.
            </p>
            <p className="text-gray-700 leading-relaxed mb-4">
              • Data will be stored securely and not shared with third parties without consent.
            </p>
            <p className="text-gray-700 leading-relaxed mb-4">
              • Please refer to our Privacy Policy for detailed information.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold mb-4" style={{ color: '#002147' }}>7. User Responsibilities</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              • Keep your login credentials confidential.
            </p>
            <p className="text-gray-700 leading-relaxed mb-4">
              • You are responsible for all activities under your account.
            </p>
            <p className="text-gray-700 leading-relaxed mb-4">
              • Notify the school immediately if you suspect unauthorized access to your account.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold mb-4" style={{ color: '#002147' }}>8. Technical Requirements</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              • A stable internet connection is required to access the Portal.
            </p>
            <p className="text-gray-700 leading-relaxed mb-4">
              • Supported browsers: Chrome, Firefox, Safari, Edge (latest versions).
            </p>
            <p className="text-gray-700 leading-relaxed mb-4">
              • The school is not responsible for technical issues on the user's end.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold mb-4" style={{ color: '#002147' }}>9. Limitation of Liability</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              • The school is not liable for any technical failures, data loss, or service interruptions.
            </p>
            <p className="text-gray-700 leading-relaxed mb-4">
              • Payment gateway issues should be directly addressed with Razorpay support.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold mb-4" style={{ color: '#002147' }}>10. Changes to Terms</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              • The school reserves the right to modify these terms at any time.
            </p>
            <p className="text-gray-700 leading-relaxed mb-4">
              • Users will be notified of significant changes via email.
            </p>
            <p className="text-gray-700 leading-relaxed mb-4">
              • Continued use of the Portal after changes constitutes acceptance of new terms.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold mb-4" style={{ color: '#002147' }}>11. Governing Law</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              • These terms are governed by the laws of India.
            </p>
            <p className="text-gray-700 leading-relaxed mb-4">
              • Any disputes will be subject to the jurisdiction of courts in the school's location.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold mb-4" style={{ color: '#002147' }}>12. Contact Information</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              For any questions regarding these Terms and Conditions, please contact us through our Contact Us page.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;